import { createSelector } from '@ngrx/store';
import { templateDraftEntityAdapter as EntityAdapter, TemplateDraftState as EntityState } from './template-draft.state';
import { TemplateDraft as Entity } from './template-draft.model';
import { AppState } from '../app-store.state';

export const selectState = (state: AppState) => state.templateDraft;

export const selectAll = createSelector(selectState, EntityAdapter.getSelectors().selectAll);

export const selectById = (entityId: number) =>
    createSelector(selectAll, (entities: Entity[]) => entities.find(e => e.id === entityId));

export const isLoading = createSelector(selectState, (state: EntityState) => state.isLoading);

export const hasErrors = createSelector(selectState, (state: EntityState) => state.error);

export const findByCorrelationId = <T>(correlationId: string) =>
    createSelector(
        selectState,
        (state: EntityState) => <T>state.history.find(h => h.correlationId === correlationId)?.payload
    );

export const currentEntityId = createSelector(selectState, (state: EntityState) => state.currentEntityId);

export const currentEntity = createSelector(selectState, (state: EntityState) => {
    return state.currentEntityId ? state.entities[state.currentEntityId] : undefined;
});

export const currentCategoryId = createSelector(selectState, (state: EntityState) => state.currentCategoryId);

export const selectByCategory = (categoryId: number) =>
    createSelector(selectAll, (entities: Entity[]) =>
        entities.filter(e => e.productCategoryId === categoryId)
    );

export const TemplateDraftSelectors = {
    selectAll,
    selectById,
    isLoading,
    hasErrors,
    findByCorrelationId,
    currentEntity,
    currentEntityId,
    currentCategoryId,
    selectByCategory
};
